import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import { TalkToAyushDialog } from "@/components/TalkToAyushDialog";
import { Button } from "@/components/ui/button";
import { BrandAvatar } from "@/components/BrandAvatar";

export function Footer() {
  return (
    <footer className="border-t border-border bg-background" data-testid="footer">
      <div className="container-px mx-auto max-w-[1600px] py-20">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <h3 className="font-display text-4xl font-extrabold uppercase leading-none text-foreground md:text-6xl">
              Let's find<br /><span className="text-cyan">your first home.</span>
            </h3>
            <p className="mt-6 max-w-md text-muted-foreground">
              City head, content creator and your guide to buying smart in Indian real estate.
            </p>
            <TalkToAyushDialog source="footer" trigger={
              <Button className="mt-8 rounded-none bg-cyan font-mono text-xs uppercase tracking-widest text-white hover:bg-cyan/90" data-testid="footer-cta">
                Book a Consultation
              </Button>
            } />
          </div>
          <div>
            <p className="mb-5 font-mono text-xs uppercase tracking-widest text-muted-foreground">Explore</p>
            <ul className="space-y-3">
              {[["Tools", "/tools"], ["Learn & Play", "/games"], ["Journal", "/blog"], ["Market News", "/news"]].map(([l, to]) => (
                <li key={to}><Link to={to} className="text-foreground transition-colors hover:text-cyan">{l}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-5 font-mono text-xs uppercase tracking-widest text-muted-foreground">Connect</p>
            <a href="https://www.instagram.com/realestatewithayush/" target="_blank" rel="noreferrer"
               className="group flex items-center gap-2 text-foreground transition-colors hover:text-cyan" data-testid="footer-instagram">
              <Instagram className="h-4 w-4" /> @realestatewithayush
              <ArrowUpRight className="h-4 w-4 opacity-0 transition-opacity group-hover:opacity-100" />
            </a>
            <Link to="/admin" className="mt-3 block font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground" data-testid="footer-admin">Admin</Link>
          </div>
        </div>
        <div className="mt-16 flex flex-col justify-between gap-4 border-t border-border pt-8 font-mono text-xs uppercase tracking-widest text-muted-foreground md:flex-row">
          <span className="flex items-center gap-2"><BrandAvatar className="h-6 w-6" /> © {new Date().getFullYear()} Real Estate with Ayush</span>
          <span>Built for first-time buyers · India</span>
        </div>
      </div>
    </footer>
  );
}
